import 'what-input'
import salvattore from 'salvattore'

import './a11y'
import debounce from './libs/debounce'

window.addEventListener('resize', debounce(() => {
  [...document.body.querySelectorAll('.js-salvattore-grid')].forEach(() => {
    salvattore.rescanMediaQueries();
  })
}, 100));
